export const getColor = (percentage: number) => {
  if (percentage < 25) {
    return '#C54326';
  }

  if (percentage < 50) {
    return '#FF7456';
  }

  if (percentage < 75) {
    return '#FFCE70';
  }

  return '#33AD90';
};

export default {};
